// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec69d46e","732":"f247b208"}[chunkId] + ".chunk.js";
};